import React from "react";
import "./PricingModal.css";

export default function PricingModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>✕</button>

        {/* Stripe Pricing Table embed */}
        <stripe-pricing-table
          pricing-table-id="prctbl_1S6ES8CagDAeI1bFDt9xPpWO"       // replace with your real table ID
          publishable-key="pk_live_qjv7ksQqFLGV5T3oYoff4oQW"    // replace with your real publishable key
        >
        </stripe-pricing-table>
      </div>
      {/* The script tag must be outside of React’s virtual DOM */}
      <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
    </div>
  );
}

